import {
  GET_NEXT_OF_KIN,
  GET_NEXT_OF_KIN_FAILURE,
  GET_NEXT_OF_KIN_SUCCESS,
  SAVE_NEXT_OF_KIN,
  SAVE_NEXT_OF_KIN_FAILURE,
  SAVE_NEXT_OF_KIN_SUCCESS,
  // other
  FETCH_OTHER_CONTACTS,
  FETCH_OTHER_CONTACTS_FAILURE,
  FETCH_OTHER_CONTACTS_SUCCESS,
  ADD_OTHER_CONTACT,
  ADD_OTHER_CONTACT_FAILURE,
  ADD_OTHER_CONTACT_SUCCESS,
  EDIT_OTHER_CONTACT,
  EDIT_OTHER_CONTACT_FAILURE,
  EDIT_OTHER_CONTACT_SUCCESS,
  DELETE_OTHER_CONTACT,
  DELETE_OTHER_CONTACT_FAILURE,
  DELETE_OTHER_CONTACT_SUCCESS,
  REMOVE_CONTACT,
  REMOVE_CONTACT_FAILURE,
  REMOVE_CONTACT_SUCCESS,
  TOGGLE_OTHER_KIN_MODAL,
  SEARCH_CONTACTS,
  SEARCH_CONTACTS_FAILURE,
  SEARCH_CONTACTS_SUCCESS,
  GET_CONTACT_SUGGESTIONS,
  GET_CONTACT_SUGGESTIONS_FAILURE,
  GET_CONTACT_SUGGESTIONS_SUCCESS,
  SEND_FAMILY_INVITE,
  SEND_FAMILY_INVITE_FAILURE,
  SEND_FAMILY_INVITE_SUCCESS,
  RESEND_FAMILY_INVITE,
  RESEND_FAMILY_INVITE_FAILURE,
  RESEND_FAMILY_INVITE_SUCCESS,
  REVOKE_FAMILY_ACCESS,
  REVOKE_FAMILY_ACCESS_FAILURE,
  REVOKE_FAMILY_ACCESS_SUCCESS,
  TOGGLE_FAMILY_INVITE_MODAL,
  FETCH_FAMILY_ACCESS,
  FETCH_FAMILY_ACCESS_FAILURE,
  FETCH_FAMILY_ACCESS_SUCCESS,
  FETCH_FAMILY_MODULE_PERMISSIONS,
  FETCH_FAMILY_MODULE_PERMISSIONS_FAILURE,
  FETCH_FAMILY_MODULE_PERMISSIONS_SUCCESS,
  SAVE_FAMILY_MODULE_OVERRIDES,
  SAVE_FAMILY_MODULE_OVERRIDES_FAILURE,
  SAVE_FAMILY_MODULE_OVERRIDES_SUCCESS,
} from "./constants";

export const getNextOfKin = (payload, onGet) => ({
  type: GET_NEXT_OF_KIN,
  payload,
  onGet,
});
export const getNextOfKinSuccess = (payload) => ({
  type: GET_NEXT_OF_KIN_SUCCESS,
  payload,
});
export const getNextOfKinFailure = (payload) => ({
  type: GET_NEXT_OF_KIN_FAILURE,
  payload,
});

export const saveNextOfKin = (payload) => ({
  type: SAVE_NEXT_OF_KIN,
  payload,
});
export const saveNextOfKinSuccess = (payload) => ({
  type: SAVE_NEXT_OF_KIN_SUCCESS,
  payload,
});
export const saveNextOfKinFailure = (payload) => ({
  type: SAVE_NEXT_OF_KIN_FAILURE,
  payload,
});

export const fetchOtherContacts = (payload) => ({
  type: FETCH_OTHER_CONTACTS,
  payload,
});
export const fetchOtherContactsSuccess = (payload) => ({
  type: FETCH_OTHER_CONTACTS_SUCCESS,
  payload,
});
export const fetchOtherContactsFailure = (payload) => ({
  type: FETCH_OTHER_CONTACTS_FAILURE,
  payload,
});

export const addOtherContact = (payload, onAdd, onError) => ({
  type: ADD_OTHER_CONTACT,
  payload,
  onAdd,
  onError,
});
export const addOtherContactSuccess = (payload) => ({
  type: ADD_OTHER_CONTACT_SUCCESS,
  payload,
});
export const addOtherContactFailure = (payload) => ({
  type: ADD_OTHER_CONTACT_FAILURE,
  payload,
});

export const editOtherContact = (payload, onEdit, onError) => ({
  type: EDIT_OTHER_CONTACT,
  payload,
  onEdit,
  onError,
});
export const editOtherContactSuccess = (payload) => ({
  type: EDIT_OTHER_CONTACT_SUCCESS,
  payload,
});
export const editOtherContactFailure = (payload) => ({
  type: EDIT_OTHER_CONTACT_FAILURE,
  payload,
});

export const deleteOtherContact = (payload, onDelete, onError) => ({
  type: DELETE_OTHER_CONTACT,
  payload,
  onDelete,
  onError,
});
export const deleteOtherContactSuccess = (payload) => ({
  type: DELETE_OTHER_CONTACT_SUCCESS,
  payload,
});
export const deleteOtherContactFailure = (payload) => ({
  type: DELETE_OTHER_CONTACT_FAILURE,
  payload,
});

export const removeContact = (payload, onSuccess, onError) => ({
  type: REMOVE_CONTACT,
  payload,
  onSuccess,
  onError,
});
export const removeContactSuccess = (payload) => ({
  type: REMOVE_CONTACT_SUCCESS,
  payload,
});
export const removeContactFailure = (payload) => ({
  type: REMOVE_CONTACT_FAILURE,
  payload,
});

export const toggleOtherKinModal = (payload) => ({
  type: TOGGLE_OTHER_KIN_MODAL,
  payload,
});

export const searchContacts = (payload) => ({
  type: SEARCH_CONTACTS,
  payload,
});
export const searchContactsSuccess = (payload) => ({
  type: SEARCH_CONTACTS_SUCCESS,
  payload,
});
export const searchContactsFailure = (payload) => ({
  type: SEARCH_CONTACTS_FAILURE,
  payload,
});

export const getContactSuggestions = (payload) => ({
  type: GET_CONTACT_SUGGESTIONS,
  payload,
});
export const getContactSuggestionsSuccess = (payload) => ({
  type: GET_CONTACT_SUGGESTIONS_SUCCESS,
  payload,
});
export const getContactSuggestionsFailure = (payload) => ({
  type: GET_CONTACT_SUGGESTIONS_FAILURE,
  payload,
});

export const sendFamilyInvite = (payload, onSuccess, onError) => ({
  type: SEND_FAMILY_INVITE,
  payload,
  onSuccess,
  onError,
});
export const sendFamilyInviteSuccess = (payload) => ({
  type: SEND_FAMILY_INVITE_SUCCESS,
  payload,
});
export const sendFamilyInviteFailure = (payload) => ({
  type: SEND_FAMILY_INVITE_FAILURE,
  payload,
});

export const resendFamilyInvite = (payload, onSuccess, onError) => ({
  type: RESEND_FAMILY_INVITE,
  payload,
  onSuccess,
  onError,
});
export const resendFamilyInviteSuccess = (payload) => ({
  type: RESEND_FAMILY_INVITE_SUCCESS,
  payload,
});
export const resendFamilyInviteFailure = (payload) => ({
  type: RESEND_FAMILY_INVITE_FAILURE,
  payload,
});

export const revokeFamilyAccess = (payload, onSuccess, onError) => ({
  type: REVOKE_FAMILY_ACCESS,
  payload,
  onSuccess,
  onError,
});
export const revokeFamilyAccessSuccess = (payload) => ({
  type: REVOKE_FAMILY_ACCESS_SUCCESS,
  payload,
});
export const revokeFamilyAccessFailure = (payload) => ({
  type: REVOKE_FAMILY_ACCESS_FAILURE,
  payload,
});

export const toggleFamilyInviteModal = (payload) => ({
  type: TOGGLE_FAMILY_INVITE_MODAL,
  payload,
});

/** Fetch Family Connect status for one or more contact ids. */
export const fetchFamilyAccess = (payload) => ({
  type: FETCH_FAMILY_ACCESS,
  payload,
});
export const fetchFamilyAccessSuccess = (payload) => ({
  type: FETCH_FAMILY_ACCESS_SUCCESS,
  payload,
});
export const fetchFamilyAccessFailure = (payload) => ({
  type: FETCH_FAMILY_ACCESS_FAILURE,
  payload,
});

export const fetchFamilyModulePermissions = (payload, onSuccess, onError) => ({
  type: FETCH_FAMILY_MODULE_PERMISSIONS,
  payload,
  onSuccess,
  onError,
});
export const fetchFamilyModulePermissionsSuccess = (payload) => ({
  type: FETCH_FAMILY_MODULE_PERMISSIONS_SUCCESS,
  payload,
});
export const fetchFamilyModulePermissionsFailure = () => ({
  type: FETCH_FAMILY_MODULE_PERMISSIONS_FAILURE,
});

export const saveFamilyModuleOverrides = (payload, onSuccess, onError) => ({
  type: SAVE_FAMILY_MODULE_OVERRIDES,
  payload,
  onSuccess,
  onError,
});
export const saveFamilyModuleOverridesSuccess = (payload) => ({
  type: SAVE_FAMILY_MODULE_OVERRIDES_SUCCESS,
  payload,
});
export const saveFamilyModuleOverridesFailure = () => ({
  type: SAVE_FAMILY_MODULE_OVERRIDES_FAILURE,
});
